export const FETCH_PERSON_AVAILABILITYS_END = "setPersonAvailabilityList";
export const LOAD_AVAILABILITY_TO_EDIT = "loadAvailabilityToEdit";
export const LOAD_PERSON_AVAILABILITY_TO_EDIT = "loadPersonAvailabilityToEdit";
export const RESET_DEFAULT_AVAILABILITY_TO_EDIT = "resetDefaultAvailability";
export const RESET_DEFAULT_NEW_PERSON_AVAILABILITY = "resetDefaultNewPersonAvailability";
export const RESET_DEFAULT_PERSON_AVAILABILITY_TO_EDIT = "resetEditDefault";
export const TOGGLE_EDIT_PERSON_AVAILABILITY_DIALOG = "toggleEditPersonAvailabilityDialog";
export const TOGGLE_NEW_PERSON_AVAILABILITY_DIALOG = "toggleNewPersonAvailabilityDialog";
export const TOGGLE_PERSON_AVAILABILITY_EDIT_STATE = "togglePersonAvailabilityEditState";
export const UPDATE_ADD_PERSON_AVAILABILITY_FIELD = "updateAddPersonAvailabilityField";
export const UPDATE_EDIT_PERSON_AVAILABILITY_FIELD = "updateEditPersonAvailabilityField";
